import { Component, ContentChild, EventEmitter, Input, Output } from "@angular/core";

import { SidebarComponent } from "@lantern/app/common/sidebar/sidebar.component";
import { SidebarSection } from "@lantern/app/common/sidebar/types";

@Component({
  selector: "ta-detail-page",
  templateUrl: "./detail-page.template.html"
})
export class DetailPageComponent {
  @ContentChild(SidebarComponent, { static: false })
  sidebarRef: SidebarComponent;

  @Input()
  headerText: string;

  @Input()
  headerButtonText?: string;

  @Input()
  headerButtonDisabled = false;

  @Input()
  headerButtonShowSpinner = true;

  @Input()
  sidebarData?: SidebarSection[];

  @Input()
  sidebarSubsectionId?: string;

  @Output()
  headerButtonClick = new EventEmitter<any>();

  @Output()
  sidebarSubsectionChange = new EventEmitter<string>();

  get headerJustification(): string {
    if (this.headerButtonText != null) {
      return "space-between";
    }
    return "flex-start";
  }
}
